import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {StateStorageService} from './state-storage.service';
import {Principal, AuthServerProvider} from '../';

@Injectable()
export class UserRouteAccessCrudService implements CanActivate {

    constructor(private router: Router, private principal: Principal, private stateStorageService: StateStorageService, private authProvider: AuthServerProvider) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        // Disable open popup on first time access URL
        if (!Window['currentUrl'] && !Window['popupNavigated'] && (state.url.split('(').length || state.url.split('?').length)) {
            Window['popupNavigated'] = true;

            // Note case ?page= so we also need slit character ?
            this.router.navigate([state.url.split('(')[0].split('?')[0], {
                outlets: {
                    popup: null,
                    notification: null,
                }
            }], {
                replaceUrl: true
            });

            return false;
        }

        // Check authority
        const accesses = route.data['permissions'];
        return this.checkLogin(state.url, accesses);
    }

    checkLogin(url: string, accesses: any): Promise<boolean> {
        const principal = this.principal;
        return Promise.resolve(principal.identity().then((account) => {
            if (account) {
                if (!accesses || accesses.length === 0) {
                    return true;
                }
                if (this.authProvider.getInfo() && this.authProvider.getInfo().role) {
                    const userPermissions = this.authProvider.getInfo().role.permission;
                    for (const permission of userPermissions) {
                        for (const access of accesses) {
                            if (permission === access) {
                                return true;
                            }
                        }
                    }
                }
                this.router.navigateByUrl('/');
                return false;
            }

            this.stateStorageService.storeUrl(url);
            this.router.navigate(['/login', {
                outlets: {
                    popup: null,
                    notification: null,
                }
            }]);

            return false;
        }));
    }

}
